import {useRef} from "react";
import {Slider, type SliderHandle, DashedBadge} from "@chayka/ui";
import {ChevronBack, ChevronForward} from "@chayka/icons";

type TRoom = {
  id: number;
  name: string;
  price: number;
  nightHoursTogether: boolean;
};

type RoomsSliderProps = {
  rooms: TRoom[];
  selectedRoom: TRoom | null;
  onSelectRoom: (room: TRoom | null) => void;
};

export const RoomsSlider: React.FC<RoomsSliderProps> = ({rooms, selectedRoom, onSelectRoom}) => {
  const sliderRef = useRef<SliderHandle>(null);

  const showChevrons = rooms.length > 1;

  return (
    <Slider
      ref={sliderRef}
      withDots
      items={rooms}
      viewportClassName="px-1 -mx-6"
      panelClassName="px-1 mx-4"
      activeIndex={rooms.findIndex((r) => r.id === selectedRoom?.id)}
      onIndexChange={(index) => onSelectRoom(rooms[index] ?? null)}
      renderItem={({item}) => (
        <div className="relative rounded-xl border border-stroke bg-background px-4 py-3 text-center gap-2 flex flex-col items-stretch">
          {showChevrons && (
            <div
              className="absolute left-2 top-1/2 -translate-y-1/2"
              onClick={() => sliderRef.current?.navigate(-1)}
            >
              <ChevronBack size={20} />
            </div>
          )}
          <DashedBadge className="mx-6">{item.name}</DashedBadge>
          <div className="text-sm">
            <span className="font-bold">{item.price} ₽</span> / час
          </div>
          {showChevrons && (
            <div
              className="absolute right-2 top-1/2 -translate-y-1/2"
              onClick={() => sliderRef.current?.navigate(1)}
            >
              <ChevronForward size={20} />
            </div>
          )}
        </div>
      )}
    />
  );
};
